import React from "react";
import { Modal, Box, Typography, Button, Stack } from "@mui/material";

interface DeleteModalProps {
  open: boolean;
  area: { formatted_address: string; place_id: string };
  onClose: () => void;
  onDelete: () => void;
}

const ConfirmDeleteMapModal: React.FC<DeleteModalProps> = ({
  open,
  area,
  onClose,
  onDelete,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        position={"absolute" as "absolute"}
        top={"50%"}
        left={"50%"}
        bgcolor={"background.paper"}
        borderRadius={"12px"}
        sx={{ transform: "translate(-50%, -50%)" }}
        width={"300px"}
        p={3}
      >
        <Typography variant="h6" textAlign="center" marginBottom={2}>
          Confirm Delete
        </Typography>
        <Typography textAlign="center">
          Are you sure you want to delete the area ?
        </Typography>
        <Typography textAlign="left">
          <strong>{area.formatted_address}</strong>
        </Typography>
        <Stack direction="row" justifyContent="space-between">
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={onDelete}>
            Delete
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ConfirmDeleteMapModal;
